$(document).ready(function() {
  var phoneInput = $('.phone-number-input');

  phoneInput.intlTelInput({
    initialCountry: 'FR',
    preferredCountries: ['FR'],
    separateDialCode: true,
    formatOnDisplay: true,
    autoHideDialCode: false,
    nationalMode: false,
    hiddenInput: 'phone_number',
    utilsScript: 'https://cdn.jsdelivr.net/npm/intl-tel-input@22.0.2/build/js/utils.js',
  });

  // This line is needed to display the error div for phone_number. Otherwise it's hidden by the intl-tel-input library
  phoneInput.parent().next('.invalid-feedback').show();

  phoneInput.closest('form').on('submit', function(e) {
    if (phoneInput.intlTelInput('isValidNumber') &&
        [
          intlTelInputUtils.numberType.MOBILE,
          intlTelInputUtils.numberType.FIXED_LINE,
          intlTelInputUtils.numberType.FIXED_LINE_OR_MOBILE,
        ].includes(phoneInput.intlTelInput('getNumberType'))) {
      phoneInput.val(phoneInput.intlTelInput('getNumber'));
    } else {
      e.preventDefault();
      phoneInput.addClass('is-invalid');
      $('html, body').animate({
        scrollTop: phoneInput.offset().top - 200
      }, 500);
      return false;
    }
  });
});
